import { PointerDragging } from "@fullcalendar/interaction";
import React, { useState, Fragment } from "react";
import { Modal, Button } from "react-bootstrap";

const PassengerModal = ({ show, handleClose, response }) => {
  // console.log(response.data);

  const printPassengerDetails = (printModal) => {
    var divContents = document.getElementById("printModal").innerHTML;
    var a = window.open("", "", "height=900, width=900");
    a.document.write(
      `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css" integrity="sha384-zCbKRCUGaJDkqS1kPbPd7TveP5iyJE0EjAuZQTgFLD2ylzuqKfdKlfG/eSrtxUkn" crossorigin="anonymous"> `
    );
    a.document.write(divContents);
    a.print();
  };

  return (
    <Fragment>
      <Modal show={show} size="lg" scrollable={true}>
        <Modal.Header className="text-primary">Passenger Details</Modal.Header>

        <Modal.Body>
          <>
            <div className="modal-body" id="printModal">
              <div className="mainContainer-modal">
                <div className="col-12">
                  <table className="table table-striped border text-center table-inverse">
                    <thead className="thead-inverse  bg-primary text-white">
                      <tr>
                        <th scope="col">Title</th>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th>Date of Birth</th>
                        <th scope="col">Passenger Type</th>
                        <th scope="col">PNR</th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {Object.keys(response).length !== 0 &&
                        response?.map((passenger) => (
                          <tr key={passenger.id}>
                            <td scope="row">{passenger?.title}</td>
                            <td>{passenger?.firstName}</td>
                            <td>{passenger?.lastName}</td>
                            <td>{passenger.birthDate}</td>
                            <td>{passenger?.passengerType}</td>
                            <td>{passenger?.pnr}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default PassengerModal;
